import { Clock, ChevronRight } from "lucide-react";
import { ptMeta } from "@/lib/propertyTypes";

// Persisted "recently viewed" strip (last 3) for the Homes / Vehicles tabs.
export default function RecentlyViewed({ kind, items, onSelect }) {
  if (!items || !items.length) return null;
  return (
    <div className="mb-6" data-testid={`recently-viewed-${kind}`}>
      <div className="flex items-center gap-2 font-mono-data text-[10px] uppercase tracking-wider text-accent mb-2">
        <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />Recently viewed
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        {items.map((item) => {
          const pt = kind === "home" ? ptMeta(item.property_type) : null;
          const PtIcon = pt?.icon;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect(item)}
              data-testid={`recently-viewed-${kind}-item`}
              className="w-full flex items-center gap-3 bg-surface border border-accent/30 rounded-xl p-3 hover:border-accent/60 transition-colors text-left group"
            >
              {item.photo ? (
                <img src={item.photo} className="w-12 h-9 rounded object-cover border border-border shrink-0" alt="" />
              ) : kind === "home" ? (
                <div className={`w-12 h-9 rounded border flex items-center justify-center shrink-0 ${pt.cls}`}>
                  <PtIcon className="w-4 h-4" strokeWidth={1.5} />
                </div>
              ) : (
                <div className="w-12 h-9 rounded border border-border bg-secondary/40 shrink-0" />
              )}
              <div className="min-w-0 flex-1">
                <div className="text-xs truncate group-hover:text-accent transition-colors">{item.title}</div>
                <div className="font-mono-data text-[10px] text-muted-foreground truncate">
                  {item.price ? `$${Number(item.price).toLocaleString()}` : "—"}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-muted-foreground group-hover:text-accent shrink-0" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
